import React from 'react'

const VehicleReports = () => {
  return (
    <div>VehicleReports</div>
  )
}

export default VehicleReports